<script setup lang="ts" generic="Value extends string">
import FormFieldTextComponent from '@shared/common/form/application/component/text/FormFieldTextComponent.vue';
import type { TextFormField } from '@shared/common/form/domain/form/field/text.form-field';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const model = defineModel<TextFormField<Value>>({ required: true });
const { t } = useI18n();
const tooltipText = computed(() => t('common.form.unknown-field'));
</script>

<template>
  <FormFieldTextComponent
    v-model="model"
    v-tooltip="{
      text: tooltipText,
    }"
    :disabled="true"
  />
</template>
